<template>
    <li class="nav-item" role="button">
        <a :class="classList" aria-current="page">
        <i :class="padding + icon"></i>
            {{navName}}
        </a>
    </li>
</template>

<script>
export default {
    name : 'NavLink',
    props : ['icon','navName','selected','linkId','isSub'],
    data(){
        let padding = ''
        if(this.isSub){
            padding = 'ps-3 '
        }
        return {
            classList :'nav-link',
            classInitial :'nav-link',
            padding : padding
        }
    },
    mounted(){
        if(this.selected==this.linkId)
            this.classList = this.classInitial +' active'
        else
            this.classList = this.classInitial
    },
    watch : {
        selected: function(value) {
            this.value
            if(value==this.linkId)
                this.classList = this.classInitial +' active'
            else
                this.classList = this.classInitial
        }
    }
}
</script>